import { styled } from "goober";
import { ClickButton } from "../ClickButton";

export const PickerRow = styled(ClickButton)`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  &:hover {
    background: var(--alpha4);
  }
  &[data-checked="true"] {
    background: var(--alpha4);
  }
`;
